import React from "react";

// Official The D AI concierge mark. Uses the approved black-and-gold The D logo.
// - `full` renders the complete logo (use where space allows).
// - default renders the compact central gold D emblem for launchers/avatars.
export function GhostIcon({ size = 40, className = "", glow = true, rounded = "rounded-lg", full = false }) {
  const src = full ? "/assets/d-logo.png" : "/assets/d-emblem.png";
  return (
    <span
      className={`inline-flex items-center justify-center overflow-hidden ${rounded} ${className}`}
      style={{
        width: size, height: size, background: "#05070d",
        border: "1px solid rgba(212,175,55,0.5)",
        boxShadow: glow ? "0 0 16px rgba(212,175,55,0.18), inset 0 0 10px rgba(212,175,55,0.08)" : "none",
      }}
      aria-hidden="true"
    >
      <img src={src} alt="" loading="lazy"
        className="h-full w-full object-contain" style={{ padding: size > 60 ? 4 : 2 }} />
    </span>
  );
}

export default GhostIcon;
